<template>
  <div class="csi-wrap">

    <!-- Subfiltros -->
    <div class="csi-subfilters px-4 pt-3 pb-2">
      <v-row dense>
        <v-col cols="12" sm="4" md="2">
          <v-select :items="fsucursales" item-value="id" v-model="search" clearable
            label="Sucursal" dense outlined hide-details prepend-inner-icon="mdi-office-building-outline" />
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-select :items="fpuntos" item-value="id" v-model="search" clearable
            label="Punto de venta" dense outlined hide-details prepend-inner-icon="mdi-point-of-sale" />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-select :items="festado_sistema" item-value="id" v-model="search" clearable
            label="Estado sistema" dense outlined hide-details prepend-inner-icon="mdi-database-check-outline" />
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-select :items="festados" item-value="id" v-model="search" clearable
            label="Estado" dense outlined hide-details prepend-inner-icon="mdi-check-circle-outline" />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-select :items="fdocsector" item-value="id" v-model="search" clearable
            label="Doc. sector" dense outlined hide-details prepend-inner-icon="mdi-file-document-outline" />
        </v-col>
      </v-row>

      <div class="d-flex align-center mt-2" style="gap:8px;">
        <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
          class="indigo--text text--darken-2 font-weight-medium">
          {{ desserts.length }} registro{{ desserts.length !== 1 ? 's' : '' }}
        </v-chip>
        <v-chip v-if="search" x-small color="amber lighten-4" class="amber--text text--darken-3">
          <v-icon left x-small>mdi-filter</v-icon> Filtro activo
        </v-chip>
      </div>
    </div>

    <v-divider />

    <v-data-table
      :headers="headers"
      :items="desserts"
      :loading="loading"
      :search="search"
      :custom-filter="custom_filter"
      dense
      loading-text="Cargando datos SIAT..."
      no-data-text="Sin datos. Seleccione período y NIT en los filtros superiores."
      class="csi-table"
    >
      <template v-slot:[`item.registradoSistema`]="{ item }">
        <v-chip x-small label
          :color="item.registradoSistema ? 'green lighten-5' : 'red lighten-5'"
          :class="item.registradoSistema ? 'green--text text--darken-2' : 'red--text text--darken-2'">
          <v-icon left x-small>{{ item.registradoSistema ? 'mdi-check' : 'mdi-close' }}</v-icon>
          {{ item.registradoSistema ? 'Sí' : 'No' }}
        </v-chip>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import { headers } from './utils.ts'
import xaxios from '@/xaxios';

export default {
    components:{ },
    data: () => ({ 
        headers,
        loading: false,
        desserts:[],
        search: '',
        fsucursales: [
            {id:'sucursal-0', text:'Sucursal 0'},
            {id:'sucursal-1', text:'Sucursal 1'},
        ],
        fpuntos: [
            {id:'punto-0', text:'Punto 0'},
            {id:'punto-1', text:'Punto 1'},
            {id:'punto-2', text:'Punto 2'},
            {id:'punto-3', text:'Punto 3'},
        ],
        festado_sistema: [
            {id:'estadosys-true', text:'Registrado'},
            {id:'estadosys-false', text:'No registrado'}, 
        ],
        festados: [
            {id:'estado-VALIDA', text:'VALIDA'}, 
        ],
        fdocsector: [
            {id:'docsector-1', text:'Sector 1'}, 
            {id:'docsector-3', text:'Sector 3'}, 
            {id:'docsector-11', text:'Sector 11'}, 
        ]
    }),
    methods:{ 
        async get_datos(endpoint,mes, anio,nit){
            this.desserts = [];
            this.loading = true;
            // window.console.log('----->>>>', nit);
            let url = process.env.VUE_APP_FACT_REST+`/facturacion/facturas/${endpoint}?mes=${mes}&anio=${anio}`;
            let config = {
                method: 'get',
                url: url,
                headers: { 'Content-Type': 'application/json',apikey: nit.apikey },
            };
            let res = await await xaxios.request(config).then(({data})=>data).catch(e=>e)

            if(res && res.data ){
                const sucursalesMap = new Map();
                const puntosMap = new Map();
                const estadosMap = new Map();
                const docSectorMap = new Map();

                for(let i=0;i<=res.data.length;i++){
                    let x = res.data[i];
                    if(!x) continue;
                    let o = {id:'sucursal-'+x.sucursalCuf,text:'Sucursal '+x.sucursalCuf};
                    sucursalesMap.set(o.id, o);
                    
                    let o2 = {id:'punto-'+x.puntoVentaCuf,text:'Punto '+x.puntoVentaCuf};
                    puntosMap.set(o2.id, o2);
                    
                    let o3 = {id:'estado-'+x.estado,text:''+x.estado};
                    estadosMap.set(o3.id, o3);
                    
                    let o4 = {id:'docsector-'+x.tipoDocumentoSectorCuf,text:''+x.tipoDocumentoSectorCuf};
                    docSectorMap.set(o4.id, o4);
                }

                this.fsucursales = Array.from(sucursalesMap.values());
                this.fpuntos = Array.from(puntosMap.values());
                this.festados = Array.from(estadosMap.values());
                this.fdocsector = Array.from(docSectorMap.values());
                
                this.desserts = res.data;
            }
            this.loading = false;
        },
        custom_filter(_value,search,item){
            if(!search) return true;

            if((search+'').startsWith('sucursal-')){
                let id = (search+'').split('-')[1];
                if(item.sucursalCuf == id) return true;
                return false;
            }
            else if((search+'').startsWith('punto-')){
                let id = (search+'').split('-')[1];
                if(item.puntoVentaCuf == id) return true;
                return false;
            }
            else if((search+'').startsWith('estadosys-')){
                let id = (search+'').split('-')[1];
                // window.console.log('item.registradoSistema == id',item.registradoSistema+'',id);
                if(item.registradoSistema+'' == id) return true;
                return false;
            }
            else if((search+'').startsWith('estado-')){
                let id = (search+'').split('-')[1];
                if(item.estado == id) return true;
                return false;
            }
            else if((search+'').startsWith('docsector-')){
                let id = (search+'').split('-')[1];
                if(item.tipoDocumentoSectorCuf == id) return true;
                return false;
            }
            // window.console.log('--???',value,search,item);
            
        },
    },
    mounted(){ 
        // this.get_datos();
    }
}

</script>

<style scoped>
.csi-wrap { background: #fff; }

.csi-subfilters { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.csi-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.csi-table >>> tbody tr:hover { background: #f0f4ff !important; }
.csi-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}
</style>
